import script from "./NaviButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NaviButton.vue?vue&type=script&setup=true&lang=js"

import "./NaviButton.vue?vue&type=style&index=0&id=51e0e4a2&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e0e4a2"]])

export default __exports__